import React from "react"

export default function LoadingScreen() {
    return (
        <div className="loader"></div>
    )
}
